import { makeStyles, createStyles, Tooltip, IconButton } from "@material-ui/core";
import React, { useState } from "react";
import MenuIcon from '@material-ui/icons/Menu';
import { TPositionAlign, PanelBase } from "./PanelBase";


const _TOOLTIP_BUTTON = 'Abrir/Fechar Toolbar';

export interface IPanelToolBarProps {
    positionAlign?: TPositionAlign,
    toolTipButton?: string,
    startOpened?: boolean,
    top?: string,
}

export const PanelToolBar: React.FC<IPanelToolBarProps> = ({
    positionAlign = 'right',
    toolTipButton = _TOOLTIP_BUTTON,
    children,
    top,
    startOpened = false
}) => {

    const useStyles = makeStyles(() =>
        createStyles({
            separator: {
                marginTop: '0px',
                marginBottom: '0px',
                borderTop: '2px solid'
            },
        }),
    );

    const styles = useStyles();

    const [expand, setExpand] = useState(startOpened);

    return (
        <PanelBase
            title=''
            colorBar=''
            width='none'
            positionAlign={positionAlign}
            clickClosePanel={() => { }}
            top={top}
            showTitle={false}
        >
            <Tooltip title={toolTipButton}>
                <IconButton
                    onClick={() => setExpand(!expand)}
                    color="inherit"
                >
                    <MenuIcon />
                </IconButton>
            </Tooltip>

            {
                expand && (
                    <>
                        <hr className={styles.separator} />
                        {children}
                    </>
                )
            }
        </PanelBase>
    )
}
